import axios from "axios";
import { useEffect, useState } from "react";
import { Modal, Spinner, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import DeleteOrderModal from "./DeleteOrderModal";
import EditOrderModal from "./EditOrderModal";

const AdminOrders = () => {
  const user = useSelector((state) => state.user);

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(
        `https://the-green-shop.herokuapp.com/api/orderDetail/getAll/${user.id}`
      )
      .then((res) => {
        setOrders(res.data);
        setLoading(false);
      });
    setLoading(true);
  }, []);

  return (
    <>
      <div className="container usersTitleDiv">
        <h1 style={{ paddingBottom: "40px" }}>Orders</h1>
        {loading && <Spinner animation="border" color="white" />}
        {!loading && (
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th>Order ID</th>
                <th>User ID</th>
                <th>Created on</th>
                <th>Updated on</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => {
                let orderId = order.id;
                return (
                  <tr key={index}>
                    <td>{order.id}</td>
                    <td>{order.UserId}</td>
                    <td>
                      {order.createdAt.slice(0, 10) +
                        " | " +
                        order.createdAt.slice(11, 19)}
                    </td>
                    <td>
                      {order.updatedAt.slice(0, 10) +
                        " | " +
                        order.updatedAt.slice(11, 19)}
                    </td>
                    <td>{order.status}</td>

                    <td>
                      <DeleteOrderModal order={order} setOrders={setOrders} />
                      <EditOrderModal order={order} setOrders={setOrders} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </div>
    </>
  );
};

export default AdminOrders;
